import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { CustomRouteDesktopViewStateService } from '../../../../services/custom-route-desktop-view-state.service';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { CUSTOM_ROUTE_DESKTOP_MAP } from '../../../../config/constants';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-more',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './more.component.html',
  styleUrls: ['./more.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MoreComponent {
  private _customRouteDesktopViewStateService = inject(CustomRouteDesktopViewStateService);
  private _sessionStorageService = inject(SessionStorageService);
  
  public handleMoreClick(): void {
    this._customRouteDesktopViewStateService.desktopViewsState.set(CUSTOM_ROUTE_DESKTOP_MAP.more);
    this._sessionStorageService.setItem('customRouteDesktopViewsState', CUSTOM_ROUTE_DESKTOP_MAP.more);
  }
}
